import { FC } from 'react';
import { useTypedDispatch, useTypedSelector } from '../../../redux/hooks';
import { Link } from 'react-router-dom';
import { LogoLink, FullLogo, IconLogo } from './Logo.styled';
import logo from '../../../assets/images/logo.svg';
import icon from '../../../assets/images/icon.svg';
import { selectMenu } from '../../../redux/menu/menuSelectors';
import { setMenuOpen } from '../../../redux/menu/menuSlice';

type Props = { scrolled?: boolean; fullOnMobile?: boolean };

export const Logo: FC<Props> = ({ scrolled = false, fullOnMobile = false }) => {
  const dispatch = useTypedDispatch();
  const isMenuOpen = useTypedSelector(selectMenu);

  const closeDrawer = () => {
    if (isMenuOpen) {
      dispatch(setMenuOpen(false));
    }
  };

  return (
    <Link to="/main" onClick={closeDrawer}>
      <LogoLink $scrolled={scrolled} $fullOnMobile={fullOnMobile}>
        <FullLogo src={logo} alt="BatteryFly" $scrolled={scrolled} $fullOnMobile={fullOnMobile} />
        <IconLogo src={icon} alt="BatteryFly" $scrolled={scrolled} $fullOnMobile={fullOnMobile} />
      </LogoLink>
    </Link>
  );
};
